import { Helmet } from "react-helmet-async";
import Hero from "./Hero";
import BuildingBlocks from "./BuildingBlocks";
import LaunchSection from "./LaunchSection";
import FeaturesSection from "./FeaturesSection";
import TestimonialsSection from "./TestimonialsSection";
import BannerSection from "../components/BannerSection";
import HighlightsSection from "./HighlightsSection";
import InvestorSection from "./Hero/InvestorSection";
import CaseStudiesSection from "./CaseStudiesSection";

interface IProps {}

const BeamPage: React.ComponentType<IProps> = () => {
  return (
    <>
      <Helmet>
        <title>AI Infrastructure For Developers • Beam</title>
      </Helmet>
      <Hero />
      <InvestorSection />
      <BuildingBlocks />
      <FeaturesSection />
      {/* <HighlightsSection /> */}
      <LaunchSection />
      <CaseStudiesSection />
      <TestimonialsSection />
      <BannerSection />
    </>
  );
};

export default BeamPage;
